// Feature flags and error handling moved to dedicated packages.
// Keep only spotlight and app info utilities here.
export * from "./spotlight";
// export * from './format/currency' // Removed: use @innolab-trader/formats instead
// export * from './reactive' // Removed: not needed for current implementation

// POC Components (organized by category)
// Error Boundaries
// Error boundaries removed from public API (unused)
// export * from './error-boundaries/ErrorMonitoringConfig' // Removed: depends on deleted monitoring

// Authentication Components - removed (not needed for current implementation)
// export * from './auth-components/AuthenticationGuard'
// export * from './auth-components/SessionRenewalNotification'

// Debug Tools - removed (causing TypeScript errors, can be re-added later if needed)
// export * from './debug-tools/debug/DebugPanel'
// export * from './debug-tools/debug/StoreStateInspector'
// export * from './debug-tools/debug/SessionDebuggingPanel'
// export * from './debug-tools/debug/WasmDebuggingTools'
// export * from './debug-tools/debug/MicrofrontendCommunicationDebugger'
// export * from './debug-tools/debug/PerformanceMonitoringDashboard'

// Monitoring Components - removed (causing build errors, can be re-added later if needed)
// export * from './monitoring/MicrofrontendMonitor'
// export * from './monitoring/webVitals'
// WebVitals moved to @innolab-trader/analytics

// Bootstrap initialization function
// Note: initializeBootstrap has moved to apps/shell.
// This file retains getAppInfo utilities for MFEs.
// Note: Config moved to @innolab-trader/config. Import only types if needed (avoid runtime dep)

export interface PackageJson {
  name: string;
  version: string;
  description?: string;
}

// Minimal options type retained for getAppInfo typing only
export interface BootstrapOptions {
  mobileApps?: {
    ios?: { appId?: string; appStoreUrl?: string }
    android?: { appId?: string; playStoreUrl?: string }
  }
}

// Store initialized app info and mobile apps globally
let bootstrapAppInfo: {
  name: string;
  version: string;
  mobileApps?: BootstrapOptions["mobileApps"];
} | null = null;

/**
 * Get the initialized app info (name, version, and mobile apps)
 */
export function getAppInfo(): {
  name: string;
  version: string;
  mobileApps?: BootstrapOptions["mobileApps"];
} | null {
  return bootstrapAppInfo;
}

// Allow shell initializer to set app info for MFEs
export function __setAppInfo(app: { name: string; version: string; mobileApps?: BootstrapOptions["mobileApps"] }) {
  bootstrapAppInfo = app
}
